export default {
	inputTypeIsPassword: (state) => state.passwordType === state.passwordTypes.password,
	getInputHintText: (state) => state.passwordType === state.passwordTypes.password
		? 'Показать пароль'
		: 'Скрыть пароль'
}
